import { cn } from '@/utils/utils';

type LoadingSpinnerProps = {
  variant?: 'screen' | 'screen-black' | 'small';
  color?: string;
  className?: string;
};
export const LoadingSpinner = ({
  variant,
  color,
  className,
}: LoadingSpinnerProps) => {
  const variantClassMap = {
    screen: 'loader-screen-gray',
    'screen-black': 'loader-screen-black',
    small: 'loader-small-gray',
  };

  const defaultClass =
    color === 'gray' ? 'loader-gray mt-[0.3rem]' : 'loader mt-[0.3rem]';
  const _className =
    variant && variantClassMap[variant]
      ? (variantClassMap[variant] ?? defaultClass)
      : defaultClass;

  return <span className={cn(_className, className)} />;
};

export const Loading = () => {
  const heightClass = 'h-full';
  const widthClass = 'w-full';

  return (
    <div
      className={`absolute bottom-0 right-0 ${heightClass} ${widthClass} flex-grow flex justify-center items-center z-50 bg-background`}
    >
      <LoadingSpinner variant="screen" />
    </div>
  );
};
